// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V3$Linear from "./V3.res.js";
import * as V3f$Linear from "./V3f.res.js";

let zero = V3$Linear.fill(0);

function plus(param, param$1) {
  return [
    param[0] + param$1[0] | 0,
    param[1] + param$1[1] | 0,
    param[2] + param$1[2] | 0
  ];
}

function minus(param, param$1) {
  return [
    param[0] - param$1[0] | 0,
    param[1] - param$1[1] | 0,
    param[2] - param$1[2] | 0
  ];
}

function scale(vec, factor) {
  return V3$Linear.map(vec, v => v * factor | 0);
}

function dot(param, param$1) {
  return ((param[0] * param$1[0] | 0) + (param[1] * param$1[1] | 0) | 0) + (param[2] * param$1[2] | 0) | 0;
}

function quadrance(vec) {
  return dot(vec, vec);
}

function length(vec) {
  return Math.sqrt(dot(vec, vec));
}

function angle(a, b) {
  let af = V3$Linear.map(a, prim => prim);
  let bf = V3$Linear.map(b, prim => prim);
  return V3f$Linear.angle(af, bf);
}

let jsonCodec = V3$Linear.jsonCodec(Jzon.int);

export {
  zero,
  plus,
  minus,
  scale,
  dot,
  quadrance,
  length,
  angle,
  jsonCodec,
}
/* zero Not a pure module */
